import React, { useState } from 'react';
import { AlertCircle, X } from 'lucide-react';

const SubscriptionStatusBanner = ({ subscription, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  if (!isVisible || !subscription) return null;

  const isPastDue = subscription.status === 'past_due';
  const isCanceled = subscription.status === 'canceled';

  if (!isPastDue && !isCanceled) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 transform transition-all duration-300 ease-out">
      <div
        className={`mx-4 mt-4 rounded-lg shadow-md border overflow-hidden ${
          isPastDue
            ? 'bg-amber-50 dark:bg-amber-900/30 border-amber-200 dark:border-amber-800'
            : 'bg-red-50 dark:bg-red-900/30 border-red-200 dark:border-red-800'
        }`}
      >
        <div className="p-4">
          <div className="flex items-center gap-3">
            {/* Icon */}
            <div
              className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${
                isPastDue
                  ? 'bg-amber-100 dark:bg-amber-800/50'
                  : 'bg-red-100 dark:bg-red-800/50'
              }`}
            >
              <AlertCircle
                className={`w-5 h-5 ${
                  isPastDue ? 'text-amber-600 dark:text-amber-400' : 'text-red-600 dark:text-red-400'
                }`}
              />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
              <h3
                className={`text-base font-semibold mb-0.5 ${
                  isPastDue
                    ? 'text-amber-900 dark:text-amber-100'
                    : 'text-red-900 dark:text-red-100'
                }`}
              >
                {isPastDue ? 'Payment Required' : 'Subscription Canceled'}
              </h3>
              <p
                className={`text-sm ${
                  isPastDue
                    ? 'text-amber-700 dark:text-amber-200'
                    : 'text-red-700 dark:text-red-200'
                }`}
              >
                {isPastDue
                  ? 'Your subscription payment failed. Please update your payment method to continue.'
                  : 'Your subscription has been canceled.'}
              </p>
            </div>

            {/* Close Button */}
            <button
              onClick={handleClose}
              className={`flex-shrink-0 p-1.5 rounded-lg transition-colors ${
                isPastDue
                  ? 'hover:bg-amber-100 dark:hover:bg-amber-800/50 text-amber-600 dark:text-amber-400'
                  : 'hover:bg-red-100 dark:hover:bg-red-800/50 text-red-600 dark:text-red-400'
              }`}
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionStatusBanner;

